import * as React from "react";
const SvgFiRrLaptopSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-laptop-slash_svg__a)">
      <path
        fill="#062147"
        d="M16 20a1 1 0 0 1-1 1H3c-1.654 0-3-1.346-3-3 0-1.304.836-2.415 2-2.828V8a1 1 0 1 1 2 0v7h4.5c.266 0 .52.105.707.293l.707.707H12a1 1 0 1 1 0 2H9.5a1 1 0 0 1-.707-.293L8.086 17H3a1 1 0 0 0 0 2h12a1 1 0 0 1 1 1m7.707 2.293a.999.999 0 1 1-1.414 1.414l-22-22A.999.999 0 1 1 1.707.293L4.884 3.47A5 5 0 0 1 7 3h10c2.757 0 5 2.243 5 5v7.172c1.164.413 2 1.524 2 2.828a3 3 0 0 1-1.826 2.76zm-3.289-3.289C20.445 19.002 21 19 21 19a1 1 0 0 0 0-2h-2.586zM6.463 5.05 16.414 15H20V8c0-1.654-1.346-3-3-3H7q-.27 0-.537.05"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-laptop-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLaptopSlash;
